export const SET_IS_NOTE_FETCHED = 'SET_IS_NOTE_FETCHED';
export const SET_IS_NOTE_SAVING = 'SET_IS_NOTE_SAVING';
export const SET_IS_NOTE_SAVED = 'SET_IS_NOTE_SAVED';
export const SET_DATE_NOTE_SAVED = 'SET_DATE_NOTE_SAVED';
export const SET_IS_SAVE_IMMEDIATELY = 'SET_IS_SAVE_IMMEDIATELY';
export const FETCH_NOTE_SUCCESS = 'FETCH_NOTE_SUCCESS';
export const UPDATE_NOTE_SUCCESS = 'UPDATE_NOTE_SUCCESS';
export const DUMMY_MUTATION = 'DUMMY_MUTATION';
